<template>
  <footer class="footer">
    <b-container>
    <b-row>
      <b-col lg="auto" class="text-center text-lg-start">
        <a href="https://www.workinaustria.com" target="_blank">
          <img :src="require('@/assets/img/logo-ABA-work.svg')" width="154" alt="ABA" style="margin-top: -15px" class="img img-fluid logo-header" />
        </a>
        <a href="https://www.come2upperaustria.com/" class="footer-logo nuxt-link-active" target="_blank">
          <img :src="require('@/assets/img/logo/logo-abaooe.png')" width="130" alt="" style="margin-top: -15px" class="img img-fluid logo-secondary" />
          <span class="sr-only">WORK in AUSTRIA</span>
        </a>
      </b-col>
      <b-col lg="6" class="d-flex justify-content-center">
        <nav class="footer-secondary-nav">
          <ul class="list-unstyled d-flex align-items-center align-items-lg-start flex-column flex-lg-row">
            <li v-for="(link, index) in generalLinks" :key="index" class="footer-secondary-nav-item d-inline-flex">
              <a :href="link.link()" target="_blank" rel="noopener noreferrer" class="footer-secondary-nav-link d-inline-flex align-items-center">
                {{ link.text }}
                <svg aria-hidden="true"
                  v-if="link.hasIcon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  width="16"
                  height="16"
                  class="icon icon-external-link"
                >
                  <path
                    d="M14.67.89a.45.45,0,0,1,.44.36V8.14a.45.45,0,0,1-.45.44.44.44,0,0,1-.44-.36V2.41L7.87,8.77a.45.45,0,0,1-.63,0,.44.44,0,0,1,0-.57l0-.06L13.6,1.78H7.87a.45.45,0,0,1-.44-.37V1.33A.44.44,0,0,1,7.79.9h6.88ZM5.77,4.44a.45.45,0,0,1,.08.89H1.77v8.89h8.89V9.78A.45.45,0,0,1,11,9.34h.08a.44.44,0,0,1,.43.37v5a.44.44,0,0,1-.36.43H1.33a.45.45,0,0,1-.44-.36V4.89a.45.45,0,0,1,.37-.44H5.77Z"
                  ></path>
                </svg>
              </a>
            </li>
          </ul>
        </nav>
      </b-col>
      <b-col cols="12" class="order-lg-1">
        <div class="footer-primary">
          <b-row align-v="center">
            <b-col lg="7" xl="6" class="order-lg-1">
              <nav class="footer-primary-nav">
                <ul class="list-inline footer-primary-nav-list">
                  <template v-for="(linkItem, index) in documentsLinks">
                    <li v-if="linkItem.visibility" :key="index" class="list-inline-item footer-primary-nav-item">
                      <a :href="linkItem.link()" target="_blank" rel="noopener noreferrer" class="footer-primary-nav-link link-hover-underlined">
                        {{ linkItem.text }}
                        <svg aria-hidden="true" v-if="linkItem.hasIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-external-link">
                          <path
                            d="M14.67.89a.45.45,0,0,1,.44.36V8.14a.45.45,0,0,1-.45.44.44.44,0,0,1-.44-.36V2.41L7.87,8.77a.45.45,0,0,1-.63,0,.44.44,0,0,1,0-.57l0-.06L13.6,1.78H7.87a.45.45,0,0,1-.44-.37V1.33A.44.44,0,0,1,7.79.9h6.88ZM5.77,4.44a.45.45,0,0,1,.08.89H1.77v8.89h8.89V9.78A.45.45,0,0,1,11,9.34h.08a.44.44,0,0,1,.43.37v5a.44.44,0,0,1-.36.43H1.33a.45.45,0,0,1-.44-.36V4.89a.45.45,0,0,1,.37-.44H5.77Z"
                          ></path>
                        </svg>
                      </a>
                    </li>
                  </template>
                </ul>
              </nav>
            </b-col>
            <b-col lg="2" class="order-lg-0">
              <nav class="social-nav">
                <ul class="social-nav-list list-unstyled list-inline">
                  <li class="social-nav-item list-inline-item">
                    <a
                      target="_blank"
                      rel="noopener"
                      href="https://www.facebook.com/ABAWorkinAustria/"
                      class="social-nav-link social-nav-link--facebook"
                    >
                      <span>
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-facebook">
                          <path
                            d="M8,.5a7.55,7.55,0,0,1,1.17,15h0V10.23h1.75l.33-2.18H9.17V6.63a1.09,1.09,0,0,1,1.22-1.18h.95V3.59s-.54-.09-1.17-.13H9.66A2.65,2.65,0,0,0,6.83,6.38h0V8.05H4.92v2.18H6.83V15.5A7.55,7.55,0,0,1,8,.5Z"
                            style="fill-rule: evenodd"
                          ></path>
                        </svg>
                      </span>
                      <span class="sr-only">Facebook</span></a
                    >
                  </li>
                  <li class="social-nav-item list-inline-item">
                    <a
                      target="_blank"
                      rel="noopener"
                      href="https://www.youtube.com/user/InvestInAustria"
                      class="social-nav-link social-nav-link--youtube"
                    >
                      <span
                        ><!---->
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-youtube">
                          <path d="M8,.5H8A7.5,7.5,0,0,1,15.5,8h0A7.5,7.5,0,0,1,8,15.5H8A7.5,7.5,0,0,1,.5,8h0A7.5,7.5,0,0,1,8,.5Z"></path>
                          <path
                            d="M8,4.46a30.62,30.62,0,0,0-4,.21,1.32,1.32,0,0,0-.89.9A13.21,13.21,0,0,0,2.94,8a13.15,13.15,0,0,0,.21,2.43,1.3,1.3,0,0,0,.89.9,30.62,30.62,0,0,0,4,.21,30.62,30.62,0,0,0,4-.21,1.24,1.24,0,0,0,.88-.89A12.63,12.63,0,0,0,13.06,8a12.71,12.71,0,0,0-.22-2.44A1.24,1.24,0,0,0,12,4.68,29.24,29.24,0,0,0,8,4.46Zm-1,2L9.62,8,7,9.51Z"
                            style="fill: #fff"
                          ></path>
                        </svg>
                        <!---->
                        <!---->
                        <!---->
                        <!---->
                        <!---->
                        <!----></span
                      >
                      <span class="sr-only">Youtube</span>
                    </a>
                  </li>
                  <li class="social-nav-item list-inline-item">
                    <a
                      target="_blank"
                      rel="noopener"
                      href="https://www.linkedin.com/company/aba-work-in-austria/"
                      class="social-nav-link social-nav-link--linkedin"
                    >
                      <span
                        ><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" class="icon icon-linkedin">
                          <path
                            d="M8,.5A7.5,7.5,0,1,1,.5,8,7.5,7.5,0,0,1,8,.5ZM5.93,6.74H4.37v5H5.93Zm4-.12a1.61,1.61,0,0,0-1.47.81h0V6.74H6.9v5H8.46V9.16c0-.61.17-1.17.93-1.17s.8.66.81,1.22h0v2.54h1.55V8.85C11.73,7.58,11.4,6.62,9.89,6.62ZM5.15,4.25a.91.91,0,1,0,.9.9A.9.9,0,0,0,5.15,4.25Z"
                            style="fill-rule: evenodd"
                          ></path>
                        </svg>
                        <!---->
                        <!---->
                        <!---->
                        <!----></span
                      >
                      <span class="sr-only">Linkedin</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </b-col>
            <b-col lg="3" xl="4" class="d-none d-lg-block text-lg-end order-lg-3"
              ><span class="small footer-primary-copyright">© {{ new Date().getFullYear() }} by Austrian Business Agency all rights reserved</span>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col cols="12" lg="2" class="order-lg-0">
        <b-row class="justify-content-end">
          <b-col cols="12" sm="6" lg="auto">
            <address class="small footer-contact text-sm-right">
              Opernring 3<br />
              A-1010 Wien
            </address>
          </b-col>
          <b-col cols="12" sm="6" lg="auto">
            <address class="small footer-contact">
              <div><a class="footer-contact-link" href="mailTo:workinaustria@aba.gv.at">workinaustria@aba.gv.at</a></div>
              <br />
            </address>
          </b-col>
          <b-col cols="12" class="d-lg-none pt-half text-center">
            <span class="small">© {{ new Date().getFullYear() }} by Austrian Business Agency all rights reserved</span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
  </footer>
</template>

<script lang="ts">
import { AppModule } from '@/store/modules/app';
import { Component, Vue } from 'vue-property-decorator';

interface LinkItem {
  text: string
  link_en?: string
  link_de: string
  hasIcon?: boolean
  link?: () => string
}

interface DocumentsLink {
  text: string
  link_en?: string
  link_de: string
  visibility: boolean
  hasIcon: boolean
  link?: () => string
}

@Component
export default class FooterComponent extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return AppModule.language;
  }

  get generalLinks() {
    const resultArr: LinkItem[] = [
      {
        text: this.translations[14000],
        link_de: 'https://www.workinaustria.com/blog',
        link_en: 'https://www.workinaustria.com/en/blog',
        hasIcon: false,
      },
      {
        text: this.translations[14001],
        link_de: 'https://www.workinaustria.com/eventkalender',
        link_en: 'https://www.workinaustria.com/en/event-calendar',
        hasIcon: false,
      },
      {
        text: this.translations[14002],
        link_de: 'https://immigration-guide.workinaustria.com',
        hasIcon: true,
      },
      {
        text: this.translations[14003],
        link_de: 'https://www.workinaustria.com/downloads',
        hasIcon: false,
      },
      {
        text: 'Partner',
        link_de: 'https://www.workinaustria.com/partner',
        hasIcon: false,
      },
      {
        text: this.translations[14004],
        link_de: 'https://aba.gv.at/presse-veranstaltungen',
        link_en: 'https://aba.gv.at/en/press-events',
        hasIcon: true,
      },
    ];

    return resultArr.map(({ ...rest }) => ({
      link: () => (rest[`link_${this.lang}` as keyof LinkItem] as string) || rest.link_de,
      ...rest,
    }));
  }

  get documentsLinks() {
    const resultArr: DocumentsLink[] = [
      {
        text: this.translations[3627],
        link_de: '/impressum',
        link_en: 'https://aba.gv.at/en/imprint/',
        visibility: true,
        hasIcon: true,
      },
      {
        text: this.translations[13886],
        link_de: 'https://www.workinaustria.com/nutzungsbedingungen/',
        link_en: 'https://www.workinaustria.com/en/talenthub-terms-of-use/',
        visibility: true,
        hasIcon: true,
      },
      {
        text: this.translations[14006],
        link_de: 'https://aba.gv.at/barrierefreiheit',
        link_en: 'https://aba.gv.at/en/accessibility/',
        visibility: true,
        hasIcon: true,
      },
      {
        text: 'Stellenausschreibungen',
        link_de: 'https://www.workinaustria.com/stellenausschreibungen',
        visibility: this.lang === 'de',
        hasIcon: false,
      },
    ];

    return resultArr.map(({ ...rest }) => ({
      link: () => (rest[`link_${this.lang}` as keyof DocumentsLink] as string) || rest.link_de,
      ...rest,
    }));
  }
}
</script>
